import api from '@/axios';

/**
 * 根据menuId获取发布的完整内容
 * @export
 * @returns
 */
 export function getPublishedPageContent(params) {
    return api.getMockdata('/user/portalPage/open/getPublishedPageContent', params);
  };

/**
 * 获取 “菜单列表"
 * @export
 * @returns
 */
export function queryEnabledMenuTree(params) {
    return api.getMockdata('/user/portalMenu/open/queryEnabledMenuTree', params);
};
